import React from 'react';
import { List, Button, Image } from 'semantic-ui-react';

import DateLocalizer from '../utils/DateLocalizer';

const InvitationList = props => {
  const { invitations, onAcceptInvitation } = props;

  return (
    <List divided relaxed="very">
      {invitations.map(invitation => (
        <List.Item key={`invitation-${invitation.id}`}>
          <List.Content floated="right">
            <Button
              primary
              size="small"
              content="Accept"
              onClick={() => onAcceptInvitation(invitation.id)}
            />
          </List.Content>
          <Image avatar src={invitation.team.logo_url} />
          <List.Content>
            <List.Header>
              You have a pending invitation from {invitation.team.name}
            </List.Header>
            <List.Description>
              Sent at {new DateLocalizer(invitation.sent_at).toDate()}
            </List.Description>
          </List.Content>
        </List.Item>
      ))}
    </List>
  );
};

export default InvitationList;



// WEBPACK FOOTER //
// ./src/components/InvitationList.js